module.exports = __webpack_public_path__ + "static/img/aboutus_pic.4d44843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus_pic.png
// module id = ddjH
// module chunks = 1